import { render, staticRenderFns } from "./ButtonsWrapper.vue?vue&type=template&id=2d1e70c0"
import script from "./ButtonsWrapper.vue?vue&type=script&lang=js"
export * from "./ButtonsWrapper.vue?vue&type=script&lang=js"
import style0 from "./ButtonsWrapper.vue?vue&type=style&index=0&id=2d1e70c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports